import { type PhaseName } from '../../../v1/phases';
import { Repository } from '../repository';
import { Phase } from './entity';

export class Phases extends Repository<Phase> {
    getByName(phase: PhaseName): Phase | undefined {
        return this.items.find((item) => item.name === phase);
    }

    getRootPhases(): Phase[] {
        return this.items.filter((phase) => !phase.rootPhaseId);
    }

    getChildPhases(parentPhase: Phase): Phase[] {
        return this.items.filter(
            (phase) => phase.rootPhaseId === parentPhase.id,
        );
    }

    getCurrentPhase(): Phase | undefined {
        const firstChild = this.items.find(
            (phase) => phase.rootPhaseId !== undefined,
        );
        const currentPhase =
            this.items.find((phase) => phase.isCurrent()) ?? firstChild;
        if (currentPhase) {
            currentPhase.setCurrent();
        }
        return currentPhase;
    }

    setCurrentPhase(id: string): void {
        this.items = this.items.map((phase) => {
            if (phase.id === id) {
                phase.setCurrent();
            } else {
                phase.unsetCurrent();
            }
            return new Phase(phase);
        });
    }
}
